export type Identifier = number | string;

export function buildCompositeKey(...parts: Identifier[]) {
  return parts.join('.');
}
